/*
 * video-covers.js
 * Video Controller Javascript
 * @Company: Strange Animals
 * @Author: Safet Ziljkic
 * ----------------------------------
 */

//no audio looping video
const homepage = {
    'perth metro': require('../../videos/homepage/video-only/homepage-hero-wa.mp4'),
    'bunbury & south west': require('../../videos/homepage/video-only/homepage-hero-wa.mp4'),
    'albany & great southern': require('../../videos/homepage/video-only/homepage-hero-wa.mp4'),
    'melbourne metro': require('../../videos/homepage/video-only/homepage-hero-vic-noaudio.mp4')
};
const finance = require('../../videos/finance/video-only/hgwa-finance.mp4');
const homedesigns = require('../../videos/house/video-only/hgwa-house.mp4');
const campaign = require('../../videos/homepage/video-only/hgwa-homepage.mp4');

// audio videos
const financeVic = require('../../videos/finance/video-audio/hgwa-finance-vic.mp4');
const financeWa = require('../../videos/finance/video-audio/hgwa-finance-wa.mp4');
const homepageVic = require('../../videos/homepage/video-audio/homepage-hero-audio.mp4');
const homepageWa = require('../../videos/homepage/video-only/homepage-hero-wa.mp4');
const house = require('../../videos/house/video-audio/hgwa-house.mp4');

const setupVideos = function(videoID, playButtonID, loopingVideo, audioVideo) {
    let videoElement = document.getElementById(videoID);
    let playButtonElement = $('#' + playButtonID);
    if (videoElement) {
        // load default looping video
        try {
            videoElement.pause();
            videoElement.src = loopingVideo;
            videoElement.muted = true;
            videoElement.loop = true;
            // videoElement.autoplay = true;
            videoElement.load();
            // play video when src loaded
            videoElement.addEventListener(
                'loadeddata',
                function() {
                    // Video is loaded and can be played
                    const playPromise = videoElement.play();
                    playPromise.catch(_ => {});

                    $('video').fadeIn(300, 'swing');
                },
                false
            );
            // play audio video when button clicked
            playButtonElement.on('click', function(e) {
                e.preventDefault();
                $('.cover-slider').slick('slickPause');
                videoElement.pause();
                playButtonElement.fadeOut();
                videoElement.src = audioVideo;
                videoElement.muted = false;
                videoElement.loop = false;
                videoElement.load();
            });
            // 'reset' when audio video has ended
            $('#' + videoID).on('ended', function() {
                $('.cover-slider').slick('slickPlay');
                videoElement.pause();
                playButtonElement.fadeIn();
                videoElement.src = loopingVideo;
                videoElement.muted = true;
                videoElement.loop = true;
                videoElement.load();
            });
        } catch (e) {}
    }
};

$(document).ready(function() {
    $('video').show();

    // re-scale image when viewport resizes
    if ($('#homepage-video').length === 0){
        $(window)
            .resize(function() {
                let vid = $('video');
                let vid_w_orig = 1920;
                let vid_h_orig = 1080;
                // get the parent element size
                let container_w = vid.parent().width();
                let container_h = vid.parent().height();
                // use largest scale factor of horizontal/vertical
                let scale_w = container_w / vid_w_orig;
                let scale_h = container_h / vid_h_orig;
                let scale = scale_w > scale_h ? scale_w : scale_h;
                // scale the video
                vid.width(scale * vid_w_orig);
                vid.height(scale * vid_h_orig);
            })
            .trigger('resize');
    }

    //*** Video Modal Controller ***
    let slidePlayButton = $('.cover-slider .slide-play-button');
    let videoModal = $('.cover-video-modal');
    let videoElement = videoModal.find('iframe');

    slidePlayButton.on('click', function(e) {
        e.preventDefault();
        let youtubeId = $(this).data('youtube-id');

        //Set and Load Modal video
        $('.cover-slider').slick('slickPause');
        videoElement.attr(
            'src',
            'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&controls=0&showinfo=0&rel=0'
        );
        //Launch and Play Modal
        videoModal.modal('show');
    });

    videoModal.on('hidden.bs.modal', function(e) {
        videoElement.attr('src', '');
        $('.cover-slider').slick('slickPlay');
    });

    $('.cover-slider').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        autoplaySpeed: 4500
    });

    //Delay 10 seconds before starting CoverSlider
    setTimeout(function() {
        $('.cover-slider').slick('slickPlay');
    }, 10000);
});

$(window).bind('load', function() {
    let currentDivision = $('#CurrentDivision')
        .text()
        .toLowerCase();
    currentDivision = currentDivision ? currentDivision : 'perth metro'; // Default to Perth Metro
    // setup videos on page load
    setTimeout(function() {
        setupVideos('homedesigns-video', 'homedesigns-play-button', homedesigns, house);
        if (currentDivision === 'melbourne metro') {
            setupVideos('homepage-video', 'homepage-play-button', homepage[currentDivision], homepageVic);
            setupVideos('finance-video', 'finance-play-button', finance, financeVic);
            setupVideos('campaign-video', 'campaign-play-button', campaign, homepageVic);
        } else {
            setupVideos('homepage-video', 'homepage-play-button', homepage[currentDivision], homepageWa);
            setupVideos('finance-video', 'finance-play-button', finance, financeWa);
            setupVideos('campaign-video', 'campaign-play-button', campaign, homepageWa);
        }
    }, 300);
});
